export default __webpack_public_path__ + "static/eluna_logo-fde48fed065848b1bc2493b65bcabb56.png";